module.exports = __webpack_public_path__ + "img/sp_menu_movie.af8469e2.svg";